// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__2AiSA","title":"Home_title__2wHkH","subtitle":"Home_subtitle__3Y9P5"};